import { useState } from 'react';
import { uniqueId } from 'lodash';
import { ContentGroupType } from '../interfaces';

export function useContentGroups(initialGroups: ContentGroupType[] = []) {
  const [groups, setGroups] = useState<ContentGroupType[]>(
    initialGroups.length ? initialGroups : [{ id: uniqueId('contentGroup_'), head: '', subHead: '', description: '' }]
  );

  const addNewContentGroup = () => {
    const newId = uniqueId('contentGroup_');
    setGroups([...groups, { id: newId, head: '', subHead: '', description: '' }]);
  };

  const removeContentGroup = (id: string) => {
    if (groups.length <= 1) return;
    setGroups(groups.filter((group) => group.id !== id));
  };

  const updateContentGroup = (id: string, field: keyof ContentGroupType, value: string) => {
    setGroups((prevGroups) => prevGroups.map((group) => (group.id === id ? { ...group, [field]: value } : group)));
  };

  return { groups, addNewContentGroup, removeContentGroup, updateContentGroup };
}
